"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "i18n", {
  enumerable: true,
  get: function get() {
    return _i18n.i18n;
  }
});
Object.defineProperty(exports, "i18nInit", {
  enumerable: true,
  get: function get() {
    return _i18n.i18nInit;
  }
});
Object.defineProperty(exports, "I18nProvider", {
  enumerable: true,
  get: function get() {
    return _i18n.I18nProvider;
  }
});
Object.defineProperty(exports, "i18nProviderHOC", {
  enumerable: true,
  get: function get() {
    return _i18n.i18nProviderHOC;
  }
});
Object.defineProperty(exports, "withTranslation", {
  enumerable: true,
  get: function get() {
    return _i18n.withTranslation;
  }
});
Object.defineProperty(exports, "useTranslation", {
  enumerable: true,
  get: function get() {
    return _i18n.useTranslation;
  }
});
Object.defineProperty(exports, "Trans", {
  enumerable: true,
  get: function get() {
    return _i18n.Trans;
  }
});
Object.defineProperty(exports, "OriginalI18nProvider", {
  enumerable: true,
  get: function get() {
    return _i18n.OriginalI18nProvider;
  }
});
Object.defineProperty(exports, "DateLocalizationProvider", {
  enumerable: true,
  get: function get() {
    return _DateLocalization.DateLocalizationProvider;
  }
});
Object.defineProperty(exports, "DateLocalizationContext", {
  enumerable: true,
  get: function get() {
    return _DateLocalization.DateLocalizationContext;
  }
});
Object.defineProperty(exports, "LANGUAGES_MAP", {
  enumerable: true,
  get: function get() {
    return _constants.LANGUAGES_MAP;
  }
});
Object.defineProperty(exports, "LANGUAGE_TO_DATE_LOCALE_MAP", {
  enumerable: true,
  get: function get() {
    return _constants.LANGUAGE_TO_DATE_LOCALE_MAP;
  }
});
Object.defineProperty(exports, "DEFAULT_LANGUAGE", {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT_LANGUAGE;
  }
});
Object.defineProperty(exports, "getLanguageKey", {
  enumerable: true,
  get: function get() {
    return _utils.getLanguageKey;
  }
});
Object.defineProperty(exports, "PluralTrans", {
  enumerable: true,
  get: function get() {
    return _PluralTrans.PluralTrans;
  }
});
exports.default = void 0;

var _i18n = require("./i18n");

var _DateLocalization = require("./DateLocalization");

var _constants = require("./constants");

var _utils = require("./utils");

var _PluralTrans = require("./PluralTrans");

var _default = _i18n.I18nProvider;
exports.default = _default;